import {context} from '../constants/context';
import assignIn from 'lodash/fp/assignIn';


// grab url params
//const defaults = queryString() || {}; //TODO cannot use queryString in nodejs - this service needs refactoring
const defaults = {};

const convertDates = obj =>
    _.each(obj, (val, key) => {
        const date = moment(obj[key]);
        if (_.isString(obj[key]) && date.isValid()) {
            return obj[key] = date;
        }
    })
;


//  store any values from context.bb_setup if it exists
if (context.bb_setup) {
    convertDates(context.bb_setup);
    assignIn(defaults, context.bb_setup);
}


// adds an answer property to a question object if the id of the question
// matches the id of the values stored in the defaults object. this would
// almost defintiely be used to get values from the querystring i.e.
// ?14393=Wedding&14392=true
const addAnswersById = function (questions) {
    if (!questions) {
        return;
    }

    if (Array.isArray(questions)) {
        return _.each(questions, (question) => {
            const id = question.id + '';

            if (!question.answer && defaults[id]) {
                return question.answer = defaults[id];
            }
        });
    } else {

        if (defaults[questions.id + '']) {
            return questions.answer = defaults[questions.id + ''];
        }
    }
};


// converts a string to a clean, snake case string. it's used to convert
// question names into snake case so they can be accessed using the object dot
// notation and match any values set using context.bb_set_up
const convertToSnakeCase = function (str) {
    str = str.toLowerCase();
    str = $.trim(str);
    // replace all punctuation and special chars
    str = str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|'’!<>;:,.~`=+-@£&%"]/g, '');
    // replace any double or more spaces
    str = str.replace(/\s{2,}/g, ' ');
    // convert to sanke case
    str = str.replace(/\s/g, '_');
    return str;
};


// takes an array of questions objects. loops through the questions gettting
// the obj.name value and converting it into snake case. then loop through the
// stored value key name and see if there is whole or partial match.
const addDynamicAnswersByName = function (questions) {
    if (Array.isArray(questions)) {
        const keys = _.keys(defaults);

        return _.each(questions, (question) => {
            const name = convertToSnakeCase(question.name);
            return _.each(keys, (key) => {
                if ((name.indexOf(`_${key}`) >= 0) || (name.indexOf(`_${key}_`) >= 0) || (name.indexOf(`${key}_`) >= 0)) {
                    if (defaults[key] && !question.answer) {
                        question.answer = defaults[key];
                        delete defaults[key];
                    }
                }
            });
        });
    }
};


// takes an object and array of key names. it loops through key names and if
// they match the key names in the stored values, then the values are added to
// calling obj.
const addAnswersByName = function (obj, keys) {
    const type = Object.prototype.toString.call(obj).slice(8, -1);

    if ((type === 'Object') && Array.isArray(keys)) {
        for (const key of Array.from(keys)) {
            // only add property to calling object if it doesn't have a property
            if (defaults[key] && !obj[key]) {
                obj[key] = defaults[key];
                // remove it once it's set otherwise there could be a lot of issues
                delete defaults[key];
            }
        }
        return;
    }
};


// takes an array of questions and an answers hash which then matches answers either
// by their key name and the questions help_text value or by question id
const addAnswersFromDefaults = (questions, answers) => {
    const defaultAnswers = answers;

    for (const question of Array.from(questions)) {
        const helpTextName = question.help_text;
        const snakeCaseName = convertToSnakeCase(question.name);

        if (defaultAnswers[question.id + '']) {
            question.answer = defaultAnswers[question.id + ''];
        } else if (defaultAnswers[helpTextName]) {
            question.answer = defaultAnswers[helpTextName];
        } else if (defaultAnswers[snakeCaseName]) {
            question.answer = defaultAnswers[snakeCaseName];
        }
    }
};


const storeDefaults = obj => assignIn(defaults, obj.bb_setup || {});

/**
 * @description
 * At the beginning all questions are in one list. This function groups conditional questions into new array, which
 * is assigned to the question with condition. It helps us to render question properly.
 */
const groupConditionalQuestions = (questions = []) => {
    const groupedQuestions = [];

    questions.forEach((question) => {
        if (question.settings && question.settings.conditional_question) {
            const condition = findQuestionById(questions, parseInt(question.settings.conditional_question));

            if (!condition) {
                return;
            }

            condition.conditionalQuestions
                ? condition.conditionalQuestions.push(question)
                : condition.conditionalQuestions = [question];
        } else {
            groupedQuestions.push(question);
        }
    });

    // Update visibility of grouped conditional questions.
    groupedQuestions.forEach(question => question.updateConditionalQuestions());
    return groupedQuestions;
};

/**
 * @description
 * Prefills all questions with known answers.
 */
const fillQuestionsWithAnswers = (questions = [], answers) => {
    if (answers) {
        // In case answers is a list of answer models (or objects) transform it into a map.
        if (Array.isArray(answers) && answers.length) {
            answers = answers.reduce((answerMap, answer) => {
                answerMap[answer.question_id] = answer.answer;
                return answerMap;
            }, {});
        }

        questions.forEach((question) => {
            if (answers[question.id]) {
                question.answer = answers[question.id];
            } else if (answers[question.name]) {
                question.answer = answers[question.name];
            }

            if (question.conditionalQuestions) {
                question.updateConditionalQuestions();
                fillQuestionsWithAnswers(question.conditionalQuestions, answers);
            }
        });
    }
};

/**
 * @description
 * Generates map of answers from the given set of questions.
 */
const getAnswers = (questions = [], answers = {}) => {
    return questions.reduce((answers, question) => {
        if (question.answer !== undefined) {
            answers[question.id] = question.answer;
        }

        if (question.conditionalQuestions) {
            return getAnswers(question.conditionalQuestions, answers);
        } else {
            return answers;
        }
    }, answers);
};

/**
 * @description
 * Perform inverse operation to what happens in group conditional questions function. It's meant to be used before
 * sending post data to the server.
 */
const unwrapGroupedQuestions = (questions = []) => {
    return (Array.isArray(questions) ? questions : [questions]).reduce((accumulator, question) => {
        if (question.conditionalQuestions) {
            return [...accumulator, question, ...unwrapGroupedQuestions(question.conditionalQuestions)];
        } else {
            return [...accumulator, question];
        }
    }, []);
};

/**
 * @description
 * Sorts questions taking into account position property. Id is used as a fallback.
 */
const sortQuestionsAccordingToPosition = (questions = []) => {
    questions.forEach((question) => {
        if (question.conditionalQuestions) {
            question.conditionalQuestions = sortQuestionsAccordingToPosition(question.conditionalQuestions);
        }
    });

    return questions.sort((a, b) => {
        // Look at position first. If position on both answers are not defined fall back to ids.
        return 'position' in a ? ('position' in b ? a.position - b.position : -1) : a.id - b.id;
    });
};

const findQuestionById = function (questions, qid) {
    for (const q of Array.from(questions)) {
        if (q.id === qid) {
            return q;
        }
    }
    return null;
};

const question = {
    getStoredData() {
        return defaults;
    },
    storeDefaults,
    addAnswersById,
    addAnswersByName,
    addDynamicAnswersByName,
    getAnswers,
    fillQuestionsWithAnswers,
    addAnswersFromDefaults,
    convertToSnakeCase,
    groupConditionalQuestions,
    sortQuestionsAccordingToPosition,
    unwrapGroupedQuestions
};

export {
    question
};

